// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { chartDiagram16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-chart-diagram': IconChartDiagram;
    }
}

/**
 * The icon component for the 'chartDiagram' icon
 */
export class IconChartDiagram extends Icon {
    public constructor() {
        super(chartDiagram16X16);
    }
}

registerIcon('icon-chart-diagram', IconChartDiagram);
export const iconChartDiagramTag = 'nimble-icon-chart-diagram';
